import { PASSWORD_MIN_LENGTH, registerInputSchema } from '@dovefiniscono/shared';
import { Link, Navigate } from '@tanstack/react-router';
import { type FormEvent, useState } from 'react';
import { errorMessage } from '../../lib/api';
import { type FieldErrors, validate } from '../../lib/form';
import { useSession } from '../../lib/session';
import { Button } from '../../ui/Button';
import { TextField } from '../../ui/Field';
import styles from './Auth.module.css';
import { AuthLayout } from './AuthLayout';
import { ProviderButtons } from './ProviderButtons';

export function RegisterPage() {
  const { signUp, passwordSignIn } = useSession();
  const [errors, setErrors] = useState<FieldErrors>({});
  const [formError, setFormError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  async function submit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const form = new FormData(event.currentTarget);
    const result = validate(registerInputSchema, {
      displayName: form.get('displayName'),
      email: form.get('email'),
      password: form.get('password'),
    });
    setErrors(result.errors ?? {});
    setFormError(null);
    if (!result.data) return;
    setLoading(true);
    try {
      await signUp(result.data);
    } catch (error) {
      setFormError(errorMessage(error));
      setLoading(false);
    }
  }

  if (passwordSignIn === false) return <Navigate to="/login" />;

  return (
    <AuthLayout title="Crea il tuo account" subtitle="Gratis. Ti serve solo un'email.">
      <ProviderButtons />
      <form className={styles.fields} onSubmit={submit} noValidate>
        <TextField
          label="Nome"
          name="displayName"
          autoComplete="given-name"
          autoFocus
          error={errors.displayName}
        />
        <TextField
          label="Email"
          name="email"
          type="email"
          autoComplete="email"
          error={errors.email}
        />
        <TextField
          label="Password"
          name="password"
          type="password"
          autoComplete="new-password"
          hint={`Almeno ${PASSWORD_MIN_LENGTH} caratteri.`}
          error={errors.password}
        />
        {formError ? (
          <p className={styles.notice} role="alert">
            {formError}
          </p>
        ) : null}
        <Button type="submit" variant="primary" className={styles.submit} loading={loading}>
          Crea account
        </Button>
      </form>
      <div className={styles.links}>
        <span>
          Hai già un account? <Link to="/login">Accedi</Link>
        </span>
      </div>
    </AuthLayout>
  );
}
